export function flattenObj(obj, parent, res = {}) {
    for (let key in obj) {
        let propName = parent ? parent + '.' + key : key;
        if (Array.isArray(obj[key]) && obj[key].length > 0) {
            res[propName] = obj[key][0];
        } else if (typeof obj[key] == 'object') {
            flattenObj(obj[key], propName, res);
        } else {
            res[propName] = obj[key];
        }
    }
    return res;
}

export const fetchMethod = async (method: (...args: any) => Promise<any>, callback: (response: any) => void, handleError: (error: any) => void, finallyMethod?: () => void) => {
    method?.()
        .then(response => {
            callback(response)
        })
        .catch(error => {
            handleError(error)
        })
        .finally(() => {
            finallyMethod?.()
        })
}

export const translit = (word: string) => {
    let answer = '';
    const converter = {
        'а': 'a',    'б': 'b',    'в': 'v',    'г': 'g',    'д': 'd',
        'е': 'e',    'ё': 'e',    'ж': 'zh',   'з': 'z',    'и': 'i',
        'й': 'y',    'к': 'k',    'л': 'l',    'м': 'm',    'н': 'n',
        'о': 'o',    'п': 'p',    'р': 'r',    'с': 's',    'т': 't',
        'у': 'u',    'ф': 'f',    'х': 'h',    'ц': 'c',    'ч': 'ch',
        'ш': 'sh',   'щ': 'sch',  'ь': '',     'ї': 'y',    'ъ': '',
        'э': 'e',    'ю': 'yu',   'я': 'ya',   ' ': "_",    'і': 'і',
        'a': 'a',    'b': 'b',    'c': 'c',    'd': 'd',    'e': 'e',
        'f': 'f',    'g': 'g',    'h': 'h',    'i': 'i',
        'k': 'k',    'l': 'l',    'm': 'm',    'n': 'n',    'o': 'o',
        'p': 'p',    'q': 'q',    'r': 'r',    's': 's',    't': 't',
        'u': 'u',    'v': 'v',    'w': 'w',    'x': 'x',    'y': 'y',
        'z': 'z',    'A': 'A',    'B': 'B',    'C': 'C',    'D': 'D',
        'E': 'E',    'F': 'F',    'G': 'G',    'H': "H",    'I': 'I',
        'J': 'J',    'K': 'K',    'L': 'L',    'M': 'M',    'N': 'N',
        'O': 'O',    'P': 'P',    'Q': 'Q',    'R': 'R',    'S': 'S',
        'T': 'T',    'U': 'U',    'V': 'V',    'W': "W",    'X': 'X',
        'Y': "Y",    'Z': 'Z',

        'А': 'A',    'Б': 'B',    'В': 'V',    'Г': 'G',    'Д': 'D',
        'Е': 'E',    'Ё': 'E',    'Ж': 'Zh',   'З': 'Z',    'И': 'I',
        'Й': 'Y',    'К': 'K',    'Л': 'L',    'М': 'M',    'Н': 'N',
        'О': 'O',    'П': 'P',    'Р': 'R',    'С': 'S',    'Т': 'T',
        'У': 'U',    'Ф': 'F',    'Х': 'H',    'Ц': 'C',    'Ч': 'Ch',
        'Ш': 'Sh',   'Щ': 'Sch',  'Ь': '',     'Ї': 'Y',    'Ъ': '',
        'Є': 'E',    'Ю': 'Yu',   'Я': 'Ya',   'І': 'I'
    };

    for (const letter of word ) {
        if (converter[letter] == undefined){
            answer += '';
        } else {
            answer += converter[letter];
        }
    }

    return answer;
}

export const getCurrentTimeKyiv = () => {
    let date = new Date();
    let currentHourKyiv = parseInt(date.toLocaleString("uk-UA", {timeZone: "Europe/Kiev", hour: '2-digit'}));
    let currentMinuteKyiv = parseInt(date.toLocaleString("uk-UA", {timeZone: "Europe/Kiev", minute:'2-digit'}));
    return [currentHourKyiv, currentMinuteKyiv];
}